module.exports = __webpack_public_path__ + "static/assets/6e9ac248714f5aaed5c67dc3acb6cc95.png";